var map = {
	"./DEPOSIT_bank.svg": [
		43314,
		3314
	],
	"./DEPOSIT_card.svg": [
		25679,
		5679
	],
	"./DEPOSIT_cash.svg": [
		70897,
		897
	],
	"./DEPOSIT_crypto.svg": [
		12569,
		2569
	],
	"./DEPOSIT_e-wallet.svg": [
		52572,
		2572
	],
	"./DEPOSIT_voucher.svg": [
		72049,
		2049
	],
	"./EXCHANGE_advanced.svg": [
		77995,
		7995
	],
	"./EXCHANGE_card.svg": [
		55611,
		5611
	],
	"./EXCHANGE_instant.svg": [
		33384,
		3384
	],
	"./EXCHANGE_levarage.svg": [
		81419,
		1419
	],
	"./EXCHANGE_recurring.svg": [
		32721,
		2721
	],
	"./SETTINGS_api.svg": [
		41901,
		1901
	],
	"./SETTINGS_documents.svg": [
		64705,
		4705
	],
	"./SETTINGS_referral.svg": [
		78177,
		8177
	],
	"./WITHDRAW_bank.svg": [
		98111,
		6238
	],
	"./WITHDRAW_crypto.svg": [
		84461,
		4461
	],
	"./WITHDRAW_e-wallet.svg": [
		75154,
		5154
	],
	"./WITHDRAW_gift.svg": [
		16213,
		6213
	],
	"./WITHDRAW_offchain.svg": [
		1488,
		1488
	],
	"./WITHDRAW_topup.svg": [
		44020,
		4020
	],
	"./WITHDRAW_voucher.svg": [
		34629,
		4629
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 31096;
module.exports = webpackAsyncContext;